var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"spinner-border",class:_vm.spinnerClass,attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }